import { render, staticRenderFns } from "./BbcsOrderStatus.vue?vue&type=template&id=06637c53&scoped=true&"
import script from "./BbcsOrderStatus.vue?vue&type=script&lang=js&"
export * from "./BbcsOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./BbcsOrderStatus.vue?vue&type=style&index=0&id=06637c53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06637c53",
  null
  
)

/* custom blocks */
import block0 from "./BbcsOrderStatus.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports